import { TableType } from '@/components/Table/types/types';
import { EmptyTableResults } from '@/components/Table/styles';
import { NoResults } from '@/components/NoResults/NoResults';
import { INVOICE_TABLE_CONFIG } from '@/bundle/_MasterAdmin/_BillingPage/ui/BIllingInvoices/InvoicesTable/const';
import NoTransactionsIcon from '@/images/NoTransactionsIcon.svg?react';
import { SinglePaymentInvoiceType } from '@/api/v1/billing/getSinglePaymentInvoicesApi';
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice';
import { MobileTable } from '@/components/Table/MobileTable/MobileTable';
import { DesktopTable } from '@/components/Table/DesktopTable';

export const InvoicesTable = ({ items = [], isLoading }: TableType<SinglePaymentInvoiceType>) => {
  const { isMobile } = useResponsiveDevice();

  const hasItems = !!items.length;
  const noUsers = !hasItems && !isLoading;

  if (noUsers) {
    return (
      <EmptyTableResults>
        <NoResults
          icon={<NoTransactionsIcon />}
          message='You have not purchased overage sending or receiving yet.'
          marginTop={80}
        />
      </EmptyTableResults>
    );
  }

  return isMobile ? (
    <MobileTable config={INVOICE_TABLE_CONFIG} items={items} isLoading={isLoading} />
  ) : (
    <DesktopTable config={INVOICE_TABLE_CONFIG} items={items} isLoading={isLoading} />
  );
};
